import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CartCtx = createContext<any>(null);
const KEY = "sc_cart";

export function CartProvider({ children }: { children: React.ReactNode }) {
  const [items, setItems] = useState<any[]>(() => JSON.parse(localStorage.getItem(KEY) || "[]"));
  const [promo, setPromo] = useState<string>(localStorage.getItem("sc_promo") || "");
  const [quote, setQuote] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [rewards, setRewards] = useState<number | null>(null);
  const [ship, setShipState] = useState<{ country: string; delivery: string }>(() => ({ country: "AU", delivery: "standard", ...JSON.parse(localStorage.getItem("sc_ship") || "{}") }));
  const setShip = (s: { country: string; delivery: string }) => { setShipState(s); localStorage.setItem("sc_ship", JSON.stringify(s)); };
  const { user } = useAuth();

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
    localStorage.setItem("sc_promo", promo);
    if (!items.length) { setQuote(null); return; }
    const payload = { items: items.map(toPayload), promo_code: promo || null, rewards: user ? rewards : null, ...ship };
    api.post("/cart/quote", payload).then((r) => setQuote(r.data)).catch(() => setQuote(null));
  }, [items, promo, rewards, user?.id, ship.country, ship.delivery]);

  const add = (item: any) => {
    const key = [item.product_id, item.metal, item.ring_size, item.engraving, JSON.stringify(item.builder || null)].join("|");
    setItems((cur) => {
      const ex = cur.find((i) => i.key === key);
      if (ex) return cur.map((i) => (i.key === key ? { ...i, qty: Math.min(10, i.qty + 1) } : i));
      return [...cur, { ...item, key, qty: 1 }];
    });
    setOpen(true);
  };
  const setQty = (key: string, qty: number) =>
    setItems((cur) => (qty < 1 ? cur.filter((i) => i.key !== key) : cur.map((i) => (i.key === key ? { ...i, qty } : i))));
  const clear = () => { setItems([]); setPromo(""); setRewards(null); };
  const count = items.reduce((a, i) => a + i.qty, 0);

  return (
    <CartCtx.Provider value={{ items, add, setQty, clear, count, quote, promo, setPromo, rewards, setRewards, open, setOpen, ship, setShip, payload: () => items.map(toPayload) }}>
      {children}
    </CartCtx.Provider>
  );
}

function toPayload(i: any) {
  return { product_id: i.product_id, metal: i.metal, ring_size: i.ring_size || null, engraving: i.engraving || null, builder: i.builder || null, qty: i.qty };
}

export const useCart = () => useContext(CartCtx);
